module.exports = __webpack_public_path__ + "static/picmed-logo-text-2-7d62347440ee5f77507fdfcd5c44c868.png";